import React from 'react';

import InputLabel from '@mui/material/InputLabel';

import aampeTheme from '../../constants/aampeTheme';

interface AampeInputLabelProps {
    label?: string;
    style?: React.CSSProperties;
    isRequired?: boolean;
    error?: string;
    touched?: boolean;
    htmlFor?: string;
}

const AampeInputLabel: React.FC<React.PropsWithChildren<AampeInputLabelProps>> =
    ({ label, style, isRequired = false, error, touched, htmlFor }) => {
        return (
            <InputLabel
                htmlFor={htmlFor}
                required={isRequired}
                error={!!error && touched}
                style={{
                    display: 'flex',
                    alignItems: 'start',
                    fontSize: aampeTheme.size.font.default,
                    fontFamily: 'Inclusive Sans Variable',
                    color: aampeTheme.colors.neutral09,
                    fontWeight: 500,
                    marginBottom: aampeTheme.spacing4(2),
                    ...style,
                }}
            >
                {label}
            </InputLabel>
        );
    };

export default AampeInputLabel;
